import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle, ArrowLeft, CreditCard } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen grid-texture flex items-center justify-center p-4">
      <div className="glass p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
        <h1 className="text-2xl font-mono font-bold mb-2">ÖDEME İPTAL EDİLDİ</h1>
        <p className="text-muted-foreground mb-6">
          Ödeme işlemi iptal edildi. Dilediğiniz zaman tekrar deneyebilirsiniz.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/credits">
            <Button className="w-full font-mono uppercase bg-primary text-black hover:bg-primary/90 rounded-none">
              <CreditCard className="w-4 h-4 mr-2" />
              ABONELİK PAKETLERİNE DÖN
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="outline" className="w-full font-mono uppercase rounded-none border-white/20">
              <ArrowLeft className="w-4 h-4 mr-2" />
              DASHBOARD'A GİT
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
